import { useNavigate, useNavigation } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import logo from './images/logo.png'
import { supaLogin, supaRegister, supabase } from './supabase';
import { useEffect, useState } from 'react';
function Login() {
  const navigation = useNavigate()
  const [mail, setMail] = useState(null)
  const [password, setPassword] = useState(null)
  const [register, setRegister] = useState(false)
  const [nickname, setNickname] = useState(null)
  const [nome, setNome] = useState(null)

  const signup = async () => {
    if (register) {
      try {
        if (!mail) {
          alert('Inserire email')
          return
        }

        if (!password) {
          alert('Inserire password')
          return
        }

        if (!nickname) {
          alert('Inserisci nickname')
          return
        }

        if (!nome) {
          alert('Inserisci nome e cognome')
          return
        }
        await supaRegister(mail, password, nickname, nome)
        await localStorage.setItem('mail', mail)
      }
      catch (error) {
        console.log(error)
      }
    } else {
      try {
        const log = await supaLogin(mail, password)
        if (log.length === 0) {
          alert('Credenziali errate')
        }
        else {
          console.log(log, 'login')
        await localStorage.setItem('mail', log[0].mail)
        await localStorage.setItem('nickname', log[0].nickname)
        await localStorage.setItem('presenze', log[0].presenze)
        await localStorage.setItem('nome', log[0].nome)
        if (log[0].accepted === true) {
          navigation('/home')
        }
         else {
          alert('Account non attivo, aspetta che Tanino ti attivi!')
         }
        }

    
      }
      catch (error) {
        console.log(error)
      }
    }
  }
 




  return (
    <Layout>
      <div className='flex w-full h-full flex-col'>
        <div className='flex flex-1 justify-center'>
          <img src={logo} alt="logo" className='w-auto h-full' />
        </div>
        <div className='flex flex-1'>
          {/* login with google component image and text */}
          <div className='flex flex-1 flex-col justify-between items-start'>
            <div className='flex flex-col justify-start items-start pt-8'>
              <h1 className='text-3xl font-black text-white'>Legionario una volta,</h1>
              <h1 className='text-3xl font-black text-white'>legionario per sempre!</h1>
            </div>
            <div className='flex w-full flex-col justify-center items-center h-full'>

              {/* login form email and password*/}
              <div className='flex flex-col w-full items-center'>
                <input type='email' placeholder='Email' className='bg-[#1E2021] text-white p-3 pl-6 rounded-full w-full mb-4' onChange={(e) => setMail(e.target.value)} />
                <input type='password' placeholder='Password' className='bg-[#1E2021] text-white p-3 pl-6 rounded-full w-full mb-4' onChange={(e) => setPassword(e.target.value)} />
                {register ? <input type='text' placeholder='Nickname' className='bg-[#1E2021] text-white p-3 pl-6 rounded-full w-full mb-4' onChange={(e) => setNickname(e.target.value)} /> : null}
                {register ? <input type='text' placeholder='Nome e cognome' className='bg-[#1E2021] text-white p-3 pl-6 rounded-full w-full mb-4' onChange={(e) => setNome(e.target.value)} /> : null}
                <button className='bg-[#839262] text-black font-bold py-2 px-4 rounded-full w-full' onClick={() => signup()}>{register ? 'Registrati' : 'Login'}</button>

                {/* register link */}
                <div className='flex flex-row w-full justify-center mt-4'>
                  <h1 className='text-white'>{!register ? 'Non hai un account?' : 'Hai già un account? Effettua il'}</h1>
                  <button className='text-[#839262] ml-1' onClick={() => setRegister(!register)}>{register ? 'Login' : 'Registrati'}</button>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Login;


